<template lang="html">
  <div class="clickable-layer blink_me" :id="_uid + '-clickable-layer'" @click="adClicked()">

  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

export default {
  props: ['clickableAd'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    var div = document.getElementById(this._uid + '-clickable-layer')
    var box1 = this.getBox(this.clickableAd)
    var box2 = this.getBox(this.clickableAd.page)

    var x = box1.x / box2.width
    var y = box1.y / box2.height
    var width = box1.width / box2.width
    var height = box1.height / box2.height

    if (width > 1) {
      width = 1
    }

    div.style.left = x * 100 + '%'
    div.style.top = y * 100 + '%'
    div.style.width = width * 100 + '%'
    div.style.height = height * 100 + '%'
  },
  computed: {
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      isScrolling: 'getIsScrolling'
    })
  },
  watch: {

  },
  methods: {
    adClicked () {
      if (!this.isScrolling) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesClickableAd', this.clickableAd.page, this.clickableAd.attributes.Link)
        // this.$cciTrackingPlugin.trackClickableAd(this.$cciTracking, this.clickableAd)
        // if (this.$store.state.currentPage.firstPage.interstitialInfo !== null && this.$store.state.currentPage.firstPage.interstitialInfo !== undefined) {
        //   this.$cciTrackingPlugin.trackInterstitialView(this.$cciTracking, this.$store.state.currentPage, this.clickableAd.attributes.Link)
        // }
        window.open(this.clickableAd.attributes.Link, '_blank')
        // window.location.href = this.clickableAd.attributes.Link
      }
    },
    getBox (obj) {
      if (obj.interstitialInfo !== undefined && obj.interstitialInfo !== null) {
        if (this.isPortrait()) {
          return {
            x: parseFloat(obj.attributes.ObjectXPos),
            y: parseFloat(obj.attributes.ObjectYPos),
            width: parseFloat(obj.attributes.InterstitialObjectWidthPortrait),
            height: parseFloat(obj.attributes.InterstitialObjectHeightPortrait)
          }
        } else {
          return {
            x: parseFloat(obj.attributes.ObjectXPos),
            y: parseFloat(obj.attributes.ObjectYPos),
            width: parseFloat(obj.attributes.InterstitialObjectWidthLandscape),
            height: parseFloat(obj.attributes.InterstitialObjectHeightLandscape)
          }
        }
      }
      return {
        x: parseFloat(obj.attributes.ObjectXPos),
        y: parseFloat(obj.attributes.ObjectYPos),
        width: parseFloat(obj.attributes.ObjectWidth),
        height: parseFloat(obj.attributes.ObjectHeight)
      }
    }
  }
}
</script>

<style lang=scss>
.clickable-layer {
  width: 100%;
  position: absolute;
  background-color: white;
  opacity: 0;
  cursor: pointer;
}

.blink_me {
  animation: blinker 1s linear 2;
}

@keyframes blinker {
  50% {
    opacity: 1;
  }
}
</style>
